"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const textInput_1 = __importDefault(require("./textInput"));
const textArea_1 = __importDefault(require("./textArea"));
const selectMenu_1 = __importDefault(require("./selectMenu"));
const dateEntry_1 = __importDefault(require("../../../dateEntry"));
const radio_1 = __importDefault(require("./radio"));
const numericWidget_1 = __importDefault(require("./numericWidget"));
const checkbox_1 = __importDefault(require("./checkbox"));
const checkboxes_1 = __importDefault(require("./checkboxes"));
const draft_1 = __importDefault(require("./draft"));
const groupSelection_1 = __importDefault(require("./groupSelection"));
const widgets = {
    CheckboxWidget: checkbox_1.default,
    CheckboxesWidget: checkboxes_1.default,
    draft: draft_1.default,
    NumericWidget: numericWidget_1.default,
    RadioWidget: radio_1.default,
    SelectWidget: selectMenu_1.default,
    textarea: textArea_1.default,
    TextWidget: textInput_1.default,
    'alt-date': dateEntry_1.default,
    'workflow-group': groupSelection_1.default
};
exports.default = widgets;
//# sourceMappingURL=index.js.map